module.exports = __webpack_public_path__ + "img/00.5176866e.png";